import * as React from 'react';
import { Popper, Paper } from "@material-ui/core";
import Button from "./Button";
import * as Colors from '../styles/colors';

interface PopperButtonProps {
    buttonContent: JSX.Element | string;
    buttonOpenedContent?: JSX.Element | string;
    buttonStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    popperStyle?: React.CSSProperties;
    paperStyle?: React.CSSProperties;
    open?: boolean;
    onChange?: (value: boolean) => void;
    windowContainer?: boolean;
    disablePortal?: boolean;
}
interface PopperButtonState {
    isOpen: boolean;
}

export default class PopperButton extends React.Component<PopperButtonProps, PopperButtonState> {
    btnRef = null;
    divRef = null;

    constructor(props: PopperButtonProps) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    get isOpen(): boolean {
        return this.props.open !== undefined ? this.props.open : this.state.isOpen;
    }

    public render() {
        return (
            <div ref={(ref => this.divRef = ref)} style={{ ...this.props.style }}>
                <Button
                    style={{ ...this.props.buttonStyle }}
                    ref={ref => this.btnRef = ref}
                    type="button"
                    onClick={(e) => {
                        this.setState({ isOpen: !this.state.isOpen })
                        if (this.props.onChange) {
                            this.props.onChange(!this.props.open);
                        }
                    }}>
                    {!this.isOpen && this.props.buttonContent}
                    {this.isOpen && (this.props.buttonOpenedContent ? this.props.buttonOpenedContent : this.props.buttonContent)}
                </Button>
                <Popper
                    style={{ zIndex: 100, ...this.props.popperStyle }}
                    disablePortal={this.props.disablePortal}
                    open={this.isOpen}
                    anchorEl={this.btnRef}
                    container={this.props.windowContainer ? undefined: this.divRef}>
                    <Paper style={{ border: `1px solid ${Colors.baseColors.darkGray}`, borderRadius: 12, ...this.props.paperStyle }}>
                        {this.props.children}
                    </Paper>
                </Popper>
            </div>
            );
    }
}